import React, { ReactNode } from 'react';
import { joinClasses } from '../../Utils/className.util';
import styles from './NavigationButton.module.scss';

interface Props {
	active: boolean;
	disabled?: boolean;
	onClick?: () => void;
	children: ReactNode;
}

const NavigationButton = ({ active, disabled, onClick, children }: Props) => {
	return (
		<div
			className={joinClasses([
				styles.button,
				active ? styles.active : '',
				disabled ? styles.disabled : '',
			])}
			onClick={onClick}>
			{children}
		</div>
	);
};

export default NavigationButton;
